import { Grid, Typography } from "@mui/material";
import "./style.css";

function NotFound()
{
    return (
        <Grid container>
            <Grid item xs={12} textAlign={"center"} mt={15}>
                <Typography variant="h1">
                   <Typography fontSize="10rem" sx={{ fontFamily: 'Alfa Slab One', }}>404</Typography>Page not found
                </Typography>
            </Grid>
        </Grid>
    );
}

export default NotFound;